<section>
  <div class="container-fluid bg-lightgrey py-5">
    <h1 class="h3 text-center">Licenza</h1>
  </div>
  <div class="container-narrow py-5">
    <p>
      I dati e i testi di di Centri d'Italia, quando non altrimenti specificato, sono rilasciati con la licenza CC-BY 4.0.
    </p>
    <p>
      Si tratta della licenza “Creative Commons Attribuzione 4.0 Internazionale”, <a href="https://creativecommons.org/licenses/by/4.0/legalcode.it">clicca
      qui</a> per visionare il testo integrale della licenza.
    </p>
    <p>
      Questa licenza prevede che i contenuti di questo sito siano liberamente distribuibili e riutilizzabili, a condizione che sia sempre indicata la
      fonte.
    </p>
  </div>
</section>
